export default __webpack_public_path__ + "static/media/purpleActiveSvg.5f8cba44.svg";